import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'face-grinning',
  size: 24,
  node: [
    ['path', { d: 'M15 10V9', key: '4dkmfx' }],
    [
      'path',
      {
        d: 'M7.084 14.302a5.12 5.12 0 009.833 0 .24.24 0 00-.235-.302H7.32a.24.24 0 00-.235.302',
        key: '1ad3z7',
      },
    ],
    ['path', { d: 'M9 10V9', key: '1lazqi' }],
    ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ],
  aliases: ['laugh'],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name FaceGrinning
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMTBWOSIgLz4KICA8cGF0aCBkPSJNNy4wODQgMTQuMzAyYTUuMTIgNS4xMiAwIDAwOS44MzMgMCAuMjQuMjQgMCAwMC0uMjM1LS4zMDJINy4zMmEuMjQuMjQgMCAwMC0uMjM1LjMwMiIgLz4KICA8cGF0aCBkPSJNOSAxMFY5IiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/face-grinning
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FaceGrinning = createLucideIcon(__iconData);

export default FaceGrinning;
